import Api from '@/services/Api'
import LocalStorage from '@/services/LocalStorageService'

const root = () => `${LocalStorage.getClientPrefix()}/monitoring`

class MonitoringCockpitService {
  about () {
    return Api().get(`${root()}/about`)
  }

  allIntegrations () {
    return Api().get(`${root()}/integrations`)
  }

  allIntegrationLogs (processType, integrationID, _startDate, _endDate, limitRows) {
    const startDate = _startDate.replaceAll(/[^\d]/g, '')
    const endDate = _endDate.replaceAll(/[^\d]/g, '')
    const body = { processType, integrationID, startDate, endDate, limitRows }

    return Api().post(`${root()}/allIntegrationLogs`, body)
  }

  showLog (processType, integrationID, date, monitoringID) {
    const body = { processType, integrationID, date, monitoringID }
    return Api().post(`${root()}/showLog`, body)
  }
}

export default new MonitoringCockpitService()
